import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WfhDetailsComponent } from './components/wfh-details/wfh-details.component';
import { WfhComponent } from './wfh.component';

const routes: Routes = [
  {
    path: '', component:WfhComponent,children:[
       {
         path:'',component: WfhDetailsComponent
       },
       {
        path:'details',component: WfhDetailsComponent
       },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WfhRoutingModule { }
